export default [
  {
    name: 'account_history',
    path: 'account_history',
    component: () =>
      import(/* webpackChunkName: "account_history" */ './index.vue')
  },
  {
    name: 'account_list',
    path: '/account_list',
    component: () =>
      import(/* webpackChunkName: "account_list" */ './AccountList.vue')
  },
  {
    name: 'TrustyCoin',
    path: '/account_list/trusty_coin',
    component: () =>
      import(
        /* webpackChunkName: "trusty_coin " */ '../TrustyCoin/TrustyCoin.vue'
      )
  },
  {
    name: 'fast_transfer',
    path: '/account_list/fast_transfer',
    meta: {
      title: 'Fast Transfer'
    },
    component: () =>
      import(/* webpackChunkName: "fast_transfer" */ './fastTransfer.vue')
  }
]
